import { createSlice } from "@reduxjs/toolkit";
import { IRequestState } from "../request.state.interface";
import { IReferal } from "../../components/ReferalCard/ReferalCard";
import getReferalsHandler from "./get-referals.handler";
import getInviteMessageHandler from "./get-invite-message.handler";

export interface IReferalRewardMilestone {
    exp: number;
    ticketsCount: number;
    fragmentsCount?: number;
}

export interface IInviteMessage {
    id: string;
    expirationDate: number;
}

export interface IReferalsState extends IRequestState {
    items: IReferal[] | null;
    milestones: IReferalRewardMilestone[];
    inviteMessage: IInviteMessage | null;
};

const initialState: IReferalsState = {
    items: null,
    milestones: [],
    inviteMessage: null,

    loading: false,
    error: '',
};

const referalsSlice = createSlice({
    name: 'referals',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        getReferalsHandler(builder);
        getInviteMessageHandler(builder);
    },
});

export default referalsSlice.reducer;